//Дополнительно меню для авторизированных пользователей

import React from 'react';
import './SideFilter.css';
import { InputCheckFilter, InputDouble, InputRadioFilter  } from '../../atoms/index.js' 
import { useSelector } from 'react-redux'

export function SideFilter(props) { 
  const { currentUser } = useSelector(state => state.currentUser)
  
  return ( 
    <form className='form__filter'> 
      <fieldset className='fieldset__filter'> 
        <InputRadioFilter 
         name={props.name}
         onChange={props.handleChoiceOwner}
         value={props.value} 
        /> 
      </fieldset>
      <fieldset className='fieldset__filter'>
          <legend className='font20EB colorGreyUp form__legend_filter '>Тип питания</legend>
          {props.type.map((item, index)=> (
            <InputCheckFilter item={item} key={index} fetching={props.fetching} onChange={props.handleChoiceType} checked={item.boolean} type='typeFoods' name={item.nameEn} />
          ))} 
        </fieldset>
        <fieldset className='fieldset__filter'>
          <legend className='font20EB colorGreyUp form__legend_filter '>Виды блюд</legend>
          {props.category.map((item, index)=> (
            <InputCheckFilter item={item} key={index} fetching={props.fetching} onChange={props.handleChoiceCategory} checked={item.boolean} type='typeFoods' name={item.nameEn}/>
          ))} 
        </fieldset>
        <fieldset className='fieldset__filter'>
          <legend className='font20EB colorGreyUp form__legend_filter '>Оборудование</legend>
          {props.kitchenware.map((item, index)=> (
            <InputCheckFilter item={item} key={index} fetching={props.fetching} checked={item.boolean} onChange={props.handleChoiceTools} type='typeFoods' name={item.nameEn}/>
          ))} 
        </fieldset>
        <fieldset className='fieldset__filter fieldset__filter_number'>
        <legend className='font20EB colorGreyUp form__legend_filter '>Калорийность  
          <span className="font14Norm colorGrey form__legend_subtitle">На порцию, ккал</span></legend> 
          {props.fetching === 'resolved' &&
          <InputDouble name='cals' id='cals' 
            onChange={props.handleCalChange} 
            minValue={props.minCalories}
            maxValue={props.maxCalories}
            minedge = {props.edge.minCalories}
            maxedge={props.edge.maxCalories}
            calsClick={props.calsClick}
            />
          }
          <div className='form__filter_foot'>
            <span className="form__filter_note font14Norm colorGrey">От</span>
            <span className="form__filter_note font14Norm colorGrey">До</span>
          </div>
          </fieldset>
          <fieldset className='fieldset__filter fieldset__filter_number'>
        <legend className='font20EB colorGreyUp form__legend_filter '>Время Приготовления  
          <span className="font14Norm colorGrey form__legend_subtitle">Без учета подготовки, мин</span></legend> 
          {props.fetching === 'resolved' &&
          <InputDouble name='time' id='time' 
            onChange={props.handleTimeChange} 
            minValue={props.minTime}
            maxValue={props.maxTime}
            minedge = {props.edge.minTime}
            maxedge={props.edge.maxTime}
            edge={props.edge}
            calsClick={props.calsClick}
            />
          }
          <div className='form__filter_foot'>
            <span className="form__filter_note font14Norm colorGrey">От</span>
            <span className="form__filter_note font14Norm colorGrey">До</span>
          </div>
          </fieldset>
          <button type='button' className='buttonGreen widt100'  onClick={props.handleReset}>Сбросить фильтры </button>
      </form>
      
  )  
}
  